import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";

import { Col, Grid, Row, ControlLabel, FormGroup } from "react-bootstrap";
import React, { Component, Fragment } from "react";

import BudgetSelect from "../Budget/BudgetSelect";
import Card from "../Card/Card";
import CreateBudgetItemSideModal from "../Budget/CreateBudgetItemSideModal";
import CreateBudgetItemsBackupSideModal from "../Budget/CreateBudgetItemsBackupSideModal";
// import CustomDatetime from "../../elements/CustomDatetime/CustomDatetime";
import DateRangePicker from "../../elements/CustomDateRangePicker/DateRangePicker";
import MainContentHeader from "../Header/MainContentHeader";
import Queries from "../../queries/queries2";
import { Query } from "react-apollo";
import Select from "react-select";
import Slider from "rc-slider";
import Spinner from "../../elements/Spinner/Spinner";
import Tooltip from "rc-tooltip";
import { compose } from "recompose";
import { graphql } from "react-apollo";
import { injectIntl } from "react-intl";
import moment from "moment";
import { withRouter } from "react-router-dom";
import CustomDatetime from "../../elements/CustomDatetime/CustomDatetime";
import { FormattedMessage } from "react-intl";
import SuperpositionHeader from "../../components/Header/SuperpositionHeader";
import ReportsTypeSelect from "../../components/Reporting/reportTypeSelect";
import BudgetTypeSelect from "../../components/Budget/budgetTypeSelect";
import { fixDateToDataBase } from "../../tools/formatDate";

const Handle = Slider.Handle;

const handle = props => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Tooltip
      prefixCls="rc-slider-tooltip"
      overlay={value}
      visible={dragging}
      placement="top"
      key={index}
    >
      <Handle value={value} {...restProps} />
    </Tooltip>
  );
};

function getPeriodColumnName(
  id,
  type,
  startDate,
  endDate
) {
  let periodColumnName = id;  // period1 or period2

  if (type === "REAL")
    periodColumnName = "(R) ";
  else
    periodColumnName = "(B) ";

  periodColumnName = periodColumnName + moment(startDate).format('MM/YYYY');
  periodColumnName = periodColumnName + "-" + moment(endDate).format('MM/YYYY');

  return periodColumnName;
}


const data = graphql(Queries.getCompanyCurrency, {
  options: ({ companyId }) => {
    return { variables: { companyId } };
  }
});

class ReportingContainer extends Component {
  constructor(props) {
    super(props);

    // console.log("66 - P=", props);

    if (props.history.action === "PUSH") {
      sessionStorage.removeItem(
        `reportingContainer_${this.props.name}_currentPeriod`
      );
      sessionStorage.removeItem(
        `reportingContainer_${this.props.name}_selectedPeriod`
      );
      sessionStorage.removeItem(`reportingContainer_${this.props.name}_year`);
    }

    //currentPeriod.value = "M", "Q", "Y"
    const savedCurrentPeriod = sessionStorage.getItem(
      `reportingContainer_${this.props.name}_currentPeriod`
    );

    //selectedPeriod = "01", "02"...
    const savedSelectedPeriod = parseInt(
      sessionStorage.getItem(
        `reportingContainer_${this.props.name}_selectedPeriod`
      )
    );

    // year = 2019, 2020...
    const savedYear = sessionStorage.getItem(
      `reportingContainer_${this.props.name}_year`
    );

    const savedFromRange = sessionStorage.getItem(
      `reportingContainer_${this.props.name}_rangeFrom`
    );
    const savedToRange = sessionStorage.getItem(
      `reportingContainer_${this.props.name}_rangeTo`
    );

    const isPopingRoute = props.history && props.history.action === "POP";

    // restore range values if any when POPing route
    const from =
      isPopingRoute && savedFromRange
        ? moment(savedFromRange)
        : moment(Date.now())
          .subtract(1, "months")
          .startOf("month")
          .startOf("day");

    // restore range values if any when POPing route
    const to =
      isPopingRoute && savedToRange
        ? moment(savedToRange)
        : moment(Date.now())
          .subtract(1, "months")
          .endOf("month")
          .endOf("day");

    console.log(
      "ReportingContainer.constructor",
      savedCurrentPeriod,
      savedSelectedPeriod,
      savedYear,
      savedFromRange,
      savedToRange,
      props
    );

    const year = !!savedYear ? parseInt(savedYear) : moment().year();
    const currentPeriod = this.buildPeriodOption(
      !!savedCurrentPeriod ? savedCurrentPeriod : "M"
    );

    // const date1 = new Date(new Date().getFullYear().toString() + "-01-01T00:00:00.000Z");
    // const date2 = new Date(new Date().getFullYear().toString() + "-12-31T00:00:00.000Z");

    this.state = {
      currentPeriod: currentPeriod,
      // currentPeriod: {
      //   value: "M",
      //   label: props.intl.formatMessage({ id: "ids_month" })
      //}, // M,Q,Y

      selectedPeriod:
        savedSelectedPeriod !== null && !!!isNaN(parseInt(savedSelectedPeriod))
          ? parseInt(savedSelectedPeriod)
          : this.getDefaultPeriod(currentPeriod.value), // month: 00/01/01 moment.month()    quarter: 00/01/02/03 moment().quarter()
      previousYear: year - 1,
      currentYear: year,

      years: [
        moment().year() - 2,
        moment().year() - 1,
        moment().year(),
        moment().year() + 1
      ],
      from,
      to,
      p1Type: "ROLLING_BUDGET",
      p1Id: "",
      p2Type: "REAL",
      p1StartDate: moment([new Date().getFullYear()]),
      p1EndDate: moment([new Date().getFullYear()]).endOf("year"),
      p1StartDateForcedValue: null,
      p1EndDateForcedValue: null,
      p1CustomeDate: false,

      p2StartDate: moment([new Date().getFullYear()]),
      p2EndDate: moment([new Date().getFullYear()]).endOf("year"),
      p2StartDateForcedValue: null,
      p2EndDateForcedValue: null,
      p2CustomeDate: false,
      // p1StartDate: new Date(
      //   new Date().setFullYear(new Date().getFullYear() - 1)
      // ).toJSON(),
      // p1EndDate: new Date().toJSON(),
      // p2StartDate: new Date(
      //   new Date().setFullYear(new Date().getFullYear() - 1)
      // ).toJSON(),
      // p2EndDate: new Date().toJSON(),
      p2Id: "",
      // const dateFrom = this.state.from && moment(this.state.from).toISOString();
      // const dateTo = this.state.to && moment(this.state.to).toISOString();
      showModal: false,
      cloneFrom: null,
      forcedValue: null
    };

    console.log("ReportingContainer - initialState", this.state);
    // this.state.selectedPeriod = this.getDefaultPeriod(
    //   this.state.currentPeriod.value
    // );
  }

  showSideModal = (args, edges) => {

    if (
      args.type === "ROLLING_BUDGET"
    ) {
      this.setState({
        showModal: true,
        cloneFrom: args,
        tiersId: args.id,
        categoryId: "",
        categoryName: args.name,
        selectedId: args.selectedId,
        edges: edges,
        isPrevious: false,
        isNext: false
      });
    }

    if (
      args.type === "BUDGET_BACKUP"
    ) {
      // if (args.type === "BUDGET_BACKUP") => read only, show only saved budget data !
    }

    if (
      args.type === "REAL"
    ) {
      // ...
    }
  };

  getDefaultPeriod = period => {
    switch (period) {
      case "M":
        return (moment().month() > 0) ? moment().month() - 1 : 0; // 0 to 11
      case "Q":
        return (moment().quarter() - 1 > 0) ? moment().quarter() - 2 : 1; // 1 to 4
      case "S":
        return Math.floor((moment().quarter() - 1) / 2);
      case "N":
        if (moment().month() < 9)
          return 0;
        else
          return 1;
      default:
        return 0;
    }
  };

  buildPeriodOption = value => {
    switch (value) {
      case "M":
        return {
          value: value,
          label: this.props.intl.formatMessage({ id: "ids_month" })
        };
      case "Q":
        return {
          value: value,
          label: this.props.intl.formatMessage({
            id: "ids_quarter"
          })
        };
      case "S":
        return {
          value: value,
          label: this.props.intl.formatMessage({
            id: "ids_semester"
          })
        };
      case "N":
        return {
          value: value,
          label: this.props.intl.formatMessage({
            id: "ids_nineMonths"
          })
        };
      case "Y":
        return {
          value: value,
          label: this.props.intl.formatMessage({ id: "ids_year" })
        };
      default:
        return {
          value: value,
          label: this.props.intl.formatMessage({ id: "ids_year" })
        };
    }
  };

  onBudgetPeriodSelect = value => {

    console.log("239 - value=", value);
    if (value.name === "p1") {
      if (value.value.type === "REAL") {
        this.setState({
          p1Type: value.value.type,
          p1Id: value.value.id,
          p1Year: value.value.year,
          p1StartDate: moment([value.value.year]),
          p1EndDate: moment([value.value.year]).endOf("year"),
          p1CustomeDate: false,
          p1StartDateForcedValue: moment([value.value.year]),
          p1EndDateForcedValue: moment([value.value.year]).endOf("year")
        });

        setTimeout(() => {
          this.setState({
            p1Type: value.value.type,
            p1Id: value.value.id,
            p1Year: value.value.year,
            p1StartDate: moment([value.value.year]),
            p1EndDate: moment([value.value.year]).endOf("year"),
            p1CustomeDate: false,
            p1StartDateForcedValue: null,
            p1EndDateForcedValue: null
          });
        }, 1500);
      }
      if (value.value.type === "ROLLING_BUDGET") {
        const state = {
          p1Type: value.value.type,
          p1Id: value.value.id,
          p1StartDate: moment([new Date().getFullYear()]),
          p1EndDate: moment([new Date().getFullYear()]).endOf("year"),
          p1CustomeDate: false,
          p1StartDateForcedValue: moment([new Date().getFullYear()]),
          p1EndDateForcedValue: moment([new Date().getFullYear()]).endOf("year")
          // p1StartDate: date1,
          // p1EndDate: date2
          // p1StartDate: new Date(
          //   new Date().setFullYear(new Date().getFullYear() - 1)
          // ),
          // p1EndDate: new Date()
        };
        this.setState(state);

        setTimeout(() => {
          this.setState({
            ...state,
            p1StartDateForcedValue: null,
            p1EndDateForcedValue: null
          });
        }, 1500);
      }
      if (value.value.type === "BUDGET_BACKUP") {
        this.setState({
          p1Type: value.value.type,
          p1Id: value.value.id,
          p1Date: value.value.date,
          p1StartDate: moment([new Date(value.value.date).getFullYear()]),
          p1EndDate: moment([new Date(value.value.date).getFullYear()]).endOf("year"),
          // p1EndDate: moment([new Date().getFullYear()]).endOf("year")
          // p1StartDate: new Date(value.value.date).setFullYear(
          //   new Date(value.value.date).getFullYear() - 1
          // ),
          // p1EndDate: moment(value.value.date),
          p1CustomeDate: false,
          p1StartDateForcedValue: moment([new Date(value.value.date).getFullYear()]),
          p1EndDateForcedValue: moment([new Date(value.value.date).getFullYear()]).endOf("year")
        });

        setTimeout(() => {
          this.setState({
            p1Type: value.value.type,
            p1Id: value.value.id,
            p1Date: value.value.date,
            p1StartDate: moment([new Date(value.value.date).getFullYear()]),
            p1EndDate: moment([new Date(value.value.date).getFullYear()]).endOf("year"),
            p1CustomeDate: false,
            p1StartDateForcedValue: null,
            p1EndDateForcedValue: null
          });
        }, 1500);
      }
    }
    if (value.name === "p2") {
      // p1Value: "",
      // p2Value: "",
      // p1Date: "",
      // p2Date: ""
      if (value.value.type === "REAL") {
        this.setState({
          p2Type: value.value.type,
          p2Id: value.value.id,
          p2Year: value.value.year,
          p2StartDate: moment([value.value.year]),
          p2EndDate: moment([value.value.year]).endOf("year"),
          p2CustomeDate: false,
          p2StartDateForcedValue: moment([value.value.year]),
          p2EndDateForcedValue: moment([value.value.year]).endOf("year")
        });

        setTimeout(() => {
          this.setState({
            p2Type: value.value.type,
            p2Id: value.value.id,
            p2Year: value.value.year,
            p2StartDate: moment([value.value.year]),
            p2EndDate: moment([value.value.year]).endOf("year"),
            p2CustomeDate: false,
            p2StartDateForcedValue: null,
            p2EndDateForcedValue: null
          });
        }, 1500);
      }
      if (value.value.type === "ROLLING_BUDGET") {
        this.setState({
          p2Type: value.value.type,
          p2Id: value.value.id,
          p2StartDate: moment([new Date().getFullYear()]),
          p2EndDate: moment([new Date().getFullYear()]).endOf("year"),
          p2CustomeDate: false,
          p2StartDateForcedValue: moment([new Date().getFullYear()]),
          p2EndDateForcedValue: moment([new Date().getFullYear()]).endOf("year")
          // p2StartDate: new Date(
          //   new Date().setFullYear(new Date().getFullYear() - 1)
          // ).toJSON(),
          // p2EndDate: new Date().toJSON()
        });

        setTimeout(() => {
          this.setState({
            p2Type: value.value.type,
            p2Id: value.value.id,
            p2StartDate: moment([new Date().getFullYear()]),
            p2EndDate: moment([new Date().getFullYear()]).endOf("year"),
            p2CustomeDate: false,
            p2StartDateForcedValue: null,
            p2EndDateForcedValue: null
          });
        }, 1500);
      }
      if (value.value.type === "BUDGET_BACKUP") {
        this.setState({
          p2Type: value.value.type,
          p2Id: value.value.id,
          p2Date: value.value.date,
          p2StartDate: moment([new Date(value.value.date).getFullYear()]),
          p2EndDate: moment([new Date(value.value.date).getFullYear()]).endOf("year"),
          // p2EndDate: moment(value.value.date),
          p2CustomeDate: false,
          p2StartDateForcedValue: moment([new Date(value.value.date).getFullYear()]),
          p2EndDateForcedValue: moment([new Date(value.value.date).getFullYear()]).endOf("year")
          // p2StartDate: moment([new Date().getFullYear()]),
          // p2EndDate: moment([new Date().getFullYear()]).endOf("year")
          // p2StartDate: new Date(value.value.date).setFullYear(
          //   new Date(value.value.date).getFullYear() - 1
          // ),
          // p2EndDate: moment(value.value.date)
        });

        setTimeout(() => {
          this.setState({
            p2Type: value.value.type,
            p2Id: value.value.id,
            p2Date: value.value.date,
            p2StartDate: moment([new Date(value.value.date).getFullYear()]),
            p2EndDate: moment([new Date(value.value.date).getFullYear()]).endOf("year"),
            p2CustomeDate: false,
            p2StartDateForcedValue: null,
            p2EndDateForcedValue: null
          });
        }, 1500);
      }
    }
  };

  onSelectedPeriod = value => {
    let period = 0;
    switch (this.state.currentPeriod.value) {
      case "M":
        period = value.index;
        break;
      case "Q":
        period = value.index;
        break;
      case "S":
        period = value.index;
        break;
      case "N":
        period = value.index;
        break;
      default:
    }

    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_selectedPeriod`,
      period
    );
    this.setState({
      selectedPeriod: period
    });
  };

  onPeriodChange = (value, str) => {
    console.log("period has changed", value);

    const selectedPeriod = this.getDefaultPeriod(value.value);

    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_currentPeriod`,
      value.value
    );

    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_selectedPeriod`,
      selectedPeriod
    );

    this.setState({
      currentPeriod: value,
      selectedPeriod
    });
  };

  onYearChange(year) {
    console.log("year", year);

    sessionStorage.setItem(`reportingContainer_${this.props.name}_year`, year);
    let boundYear = Math.max(year, 2015);
    boundYear = Math.min(boundYear, moment().year() + 2);

    this.setState({
      previousYear: boundYear - 1,
      currentYear: boundYear,
      years: [boundYear - 2, boundYear - 1, boundYear, boundYear + 1]
    });
  }

  handleRangeChange = rangeState => {
    console.log("384 - rangeState=", rangeState);
    this.setState({ from: rangeState.from, to: rangeState.to });
    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_rangeFrom`,
      rangeState.from.toISOString()
    );
    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_rangeTo`,
      rangeState.to.toISOString()
    );
  };


  handleRangeChangeDu = (from, to) => {
    console.log("426 - rangeState=", from, to);
    this.setState({ from: from, to: to, forcedValue: to });

    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_rangeFrom`,
      from.toISOString()
    );
    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_rangeTo`,
      to.toISOString()
    );

    setTimeout(() => {
      this.setState({ from: from, to: to, forcedValue: null });
    }, 1500);
  };
  handleRangeChangeAu = (from, to) => {
    console.log("439 - rangeState=", from, to);
    this.setState({ from: from, to: to, forcedValue: null });
    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_rangeFrom`,
      from.toISOString()
    );
    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_rangeTo`,
      to.toISOString()
    );
  };

  handleRangeChangeBudget1 = rangeState => {
    console.log("396 - rangeState=", rangeState);
    console.log("398 - state=", this.state);
    console.log("399 - props=", this.props);

    this.setState({ p1StartDate: rangeState.from, p1EndDate: rangeState.to, p1CustomeDate: true });
    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_p1StartDate`,
      rangeState.from.toISOString()
    );
    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_p1EndDate`,
      rangeState.to.toISOString()
    );
  };

  handleRangeChangeBudget1Du = (from, to) => {
    this.setState({ p1StartDate: from, p1EndDate: to, p1CustomeDate: true });
    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_p1StartDate`,
      from.toISOString()
    );
    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_p1EndDate`,
      to.toISOString()
    );
  };

  handleRangeChangeBudget1Au = (from, to) => {
    this.setState({ p1StartDate: from, p1EndDate: to, p1CustomeDate: true });
    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_p1StartDate`,
      from.toISOString()
    );
    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_p1EndDate`,
      to.toISOString()
    );
  };

  handleRangeChangeBudget2 = rangeState => {
    this.setState({ p2StartDate: rangeState.from, p2EndDate: rangeState.to, p2CustomeDate: true });
    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_p2StartDate`,
      rangeState.from.toISOString()
    );
    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_p2EndDate`,
      rangeState.to.toISOString()
    );
  };

  handleRangeChangeBudget2Du = (from, to) => {
    this.setState({ p2StartDate: from, p2EndDate: to, p2CustomeDate: true });
    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_p2StartDate`,
      from.toISOString()
    );
    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_p2EndDate`,
      to.toISOString()
    );
  };
  handleRangeChangeBudget2Au = (from, to) => {
    this.setState({ p2StartDate: from, p2EndDate: to, p2CustomeDate: true });
    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_p2StartDate`,
      from.toISOString()
    );
    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_p2EndDate`,
      to.toISOString()
    );
  };

  componentDidMount = () => {
    const locale = `${this.props.intl.locale.split("-")[0]}`;
    if (locale !== "en") {
      // en is enabled by default already
      import(`moment/locale/${locale}`).then(() => {
        moment.locale(locale);
      });
    }
  };

  hideSideBar = () => {
    this.setState({
      showModal: false,
      showBackupModal: false,
      cloneFrom: null
      // tiersId: "",
      // categoryId: ""
    });
  };

  render() {
    let marks = {};

    this.state.years.map(o => {
      return (marks[o] = <strong>{o}</strong>);
    });

    const minYear = Math.min(...this.state.years);
    const maxYear = Math.max(...this.state.years);

    let {
      currentPeriod,
      selectedPeriod,
      currentYear,
      previousYear,
      years
    } = this.state;

    const Chart = this.props.Chart;
    const showChart =
      this.props.showChart === undefined || this.props.showChart;
    const showPeriodSelect =
      this.props.showPeriodSelect === undefined || this.props.showPeriodSelect;

    if (!!!this.props.data) { // || (this.props.data && this.props.data.loading)) {
      return <Spinner size="lg" fullScreen />;
    }

    // console.log("512 - state=", this.state);
    const dateFrom = this.state.from;
    const dateTo = this.state.to;
    const displayDateFrom = this.state.from && moment(this.state.from);
    const displayDateTo = this.state.to && moment(this.state.to);
    const displayDateFromStr = displayDateFrom && displayDateFrom.format("L");
    const displayDateToStr = displayDateTo && displayDateTo.format("L");
    const displayDateFromDate = displayDateFrom && displayDateFrom.toDate();
    const displayDateToDate = displayDateTo && displayDateTo.toDate();

    const p1StartDateDisplay =
      this.state.p1StartDate && moment(this.state.p1StartDate);
    const p1EndDateDisplay =
      this.state.p1EndDate && moment(this.state.p1EndDate);
    const displayDatep1Start =
      p1StartDateDisplay && p1StartDateDisplay.toDate();
    const displayDatep1End = p1EndDateDisplay && p1EndDateDisplay.toDate();
    const p2StartDateDisplay =
      this.state.p2StartDate && moment(this.state.p2StartDate);
    const p2EndDateDisplay =
      this.state.p2EndDate && moment(this.state.p2EndDate);
    const displayDatep2Start =
      p2StartDateDisplay && p2StartDateDisplay.toDate();
    const displayDatep2End = p2EndDateDisplay && p2EndDateDisplay.toDate();

    const { companyDefaultInfos } = this.props;

    const currencyId =
      companyDefaultInfos &&
      companyDefaultInfos.company &&
      companyDefaultInfos.company.currency &&
      companyDefaultInfos.company.currency.id;

    const isCategoryBudgets = !!this.state.categoryId;
    // console.log("513 - ReportingContainer.state", this.state);

    // const tabFromSession = sessionStorage.getItem(
    //   `reportingContainer_${this.props.name}_currentTab`
    // );
    // const keyTab = tabFromSession ? tabFromSession : "clientPerf";


    const title = (this.state.categoryName) ?
      (<div>
        {this.props.intl.formatMessage({ id: "ids_budget" }) +
          " " + this.props.intl.formatMessage({ id: "ids_colon" }) + " "}
        <span style={{ fontWeight: "bold" }} >
          {this.state.categoryName}
        </span>
      </div>) : (
        <div>
          {this.props.intl.formatMessage({ id: "ids_addBudgetItem" })}
        </div>
      )

    // console.log("731 - P=", this.props);
    // console.log("737 - S=", this.state);

    const period1Text = getPeriodColumnName("period1", this.state.p1Type, this.state.p1StartDate, this.state.p1EndDate);
    const period2Text = getPeriodColumnName("period2", this.state.p2Type, this.state.p2StartDate, this.state.p2EndDate);

    return (
      <div>
        <FormattedMessage id={this.props.header}>
          {backBtnText => (
            <SuperpositionHeader
              backBtnText={backBtnText}
              transparent={true}
              handleMinimizeSidebar={this.props.handleMinimizeSidebar}
            >
            </SuperpositionHeader>
          )}
        </FormattedMessage>
        <Grid fluid>

          <div className="main-content" style={{ marginTop: "32px" }}>

            {this.props.hideReportsTypeSelect !== true ? (
              <Row>
                <div>
                  <Col xs={12} sm={4} lg={4} mdOffset={4}>
                    <ReportsTypeSelect
                      value={this.props.type}
                      showNewButton={false}
                      companyId={this.props.companyId}
                      intl={this.props.intl}
                      history={this.props.history}
                      role={this.props.role}
                      path={this.props.path}
                    >
                    </ReportsTypeSelect>
                  </Col>
                </div>
              </Row>
            ) : (
              <div />
            )
            }

            {this.props.hideBudgetTypeSelect !== true ? (
              <Row>
                <div>
                  <Col xs={12} sm={5} lg={5} mdOffset={3}>
                    <BudgetTypeSelect
                      value={this.props.type}
                      showNewButton={false}
                      companyId={this.props.companyId}
                      intl={this.props.intl}
                      history={this.props.history}
                      role={this.props.role}
                      path={this.props.path}
                    >
                    </BudgetTypeSelect>
                  </Col>
                </div>
              </Row>
            ) : (
              <div />
            )
            }


            {/* <MainContentHeader name={this.props.header} /> */}
            <CreateBudgetItemSideModal
              title={title}
              categoryName={this.state.categoryName}
              //   this.props.intl.formatMessage({ id: "ids_budget" }) +
              //   " " +
              //   this.state.categoryName ||
              //   this.props.intl.formatMessage({ id: "ids_addBudgetItem" })
              // }
              sideModalVisible={this.state.showModal}
              close={this.hideSideBar}
              companyId={this.props.companyId}
              tiersId={
                this.state.categoryId
                  ? this.state.cloneFrom &&
                  this.state.cloneFrom.budgetTiersSupplier &&
                  this.state.cloneFrom.budgetTiersSupplier.id
                  : this.state.cloneFrom && this.state.cloneFrom.id
              }
              categoryId={this.state.categoryId}
              projectId={
                (this.state.cloneFrom &&
                  this.state.cloneFrom.budgetProject &&
                  this.state.cloneFrom.budgetProject.id) ||
                ""
              }
              tiersClientId={
                this.state.cloneFrom &&
                this.state.cloneFrom.budgetTiersClient &&
                this.state.cloneFrom.budgetTiersClient.id
              }
              isReal={this.state.cloneFrom && this.state.cloneFrom.budgetIsReal}
              currencyId={currencyId}
              intl={this.props.intl}
              cloneFrom={this.state.cloneFrom}
              goPreviousBudget={
                isCategoryBudgets
                  ? this.handleCategoryBudgetGoPrevious
                  : this.handleBudgetClientGoPrevious
              }
              goNextBudget={
                isCategoryBudgets
                  ? this.handleCategoryBudgetGoNext
                  : this.handleBudgetClientGoNext
              }
              skipPrevious={!!!this.state.isPrevious}
              skipNext={!!!this.state.isNext}
              previousNextCommand={this.state.previousNextCommand}
              setPreviousNextCommand={this.handleBudgetSetPreviousNextCommand}
              sendNotification={this.props.sendNotification}
            />

            <div className="margin-top-40">

              {!!this.props.showBudgetComparator && (
                <Fragment>
                  <Card
                  // title={this.props.intl.formatMessage({ id: "ids_modifyPeriod" })}
                  >
                    <Grid fluid>
                      <Row sm="8">
                        <Col>
                          <FormGroup>
                            {/* <ControlLabel
                              style={{
                                marginRight: "10px",
                                paddingBottom: "5px",
                                float: "left"
                              }}>
                              <FormattedMessage id="ids_period" />
                          &nbsp;
                          1
                        </ControlLabel> */}
                          </FormGroup>
                        </Col>


                        <Col sm={3}>
                          <BudgetSelect
                            companyId={this.props.companyId}
                            onSelect={this.onBudgetPeriodSelect}
                            type={this.state.p1Type}
                            id={this.state.p1Id}
                            year={this.state.p1Year}
                            date={this.state.p1Date}
                            name="p1"
                            customDate={this.state.p1CustomeDate}
                          />
                        </Col>

                        <Col>
                          <FormGroup>
                            <ControlLabel
                              style={{
                                marginRight: "10px",
                                marginLeft: "20px",
                                paddingBottom: "5px",
                                float: "left"
                              }}>
                              <FormattedMessage id="ids_dateDu" />
                            </ControlLabel>

                            <div style={{ float: "left" }}>
                              <CustomDatetime
                                inputProps={{
                                  disabled: false,
                                  onClick: e => e.target.select()
                                }}
                                locale={this.props.locale}
                                defaultValue={displayDatep1Start}
                                value={this.state.p1StartDateForcedValue}
                                onBlur={e => {
                                  console.log("e=", e);
                                  this.handleRangeChangeBudget1Du(
                                    moment(e).startOf("day")._d,
                                    moment(displayDatep1End).endOf("day")._d
                                    // moment(e).endOf("month")._d
                                  );
                                }}
                              />
                            </div>
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <ControlLabel
                              style={{
                                marginRight: "10px",
                                marginLeft: "20px",
                                paddingBottom: "5px",
                                float: "left"
                              }}>
                              <FormattedMessage
                                id="ids_dateAu"
                                description="tax date au"
                                defaultMessage="Au"
                              />
                            </ControlLabel>

                            <div style={{ float: "left" }}>
                              <CustomDatetime
                                inputProps={{
                                  disabled: false,
                                  onClick: e => e.target.select()
                                }}
                                locale={this.props.locale}
                                defaultValue={displayDatep1End}
                                // forcedValue={this.state.forcedValue}   
                                value={this.state.p1EndDateForcedValue}
                                onBlur={e => {
                                  console.log("e=", e);
                                  this.handleRangeChangeBudget1Au(
                                    moment(displayDatep1Start).startOf("day")._d,
                                    moment(e).endOf("day")._d
                                  );
                                }}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row sm="8">
                        <Col>
                          <FormGroup>
                            {/* <ControlLabel
                              style={{
                                marginRight: "10px",
                                paddingBottom: "5px",
                                float: "left"
                              }}>
                              <FormattedMessage id="ids_period" />
                          &nbsp;
                          2
                        </ControlLabel> */}
                          </FormGroup>
                        </Col>


                        <Col sm={3}>
                          <BudgetSelect
                            companyId={this.props.companyId}
                            onSelect={this.onBudgetPeriodSelect}
                            type={this.state.p2Type}
                            id={this.state.p2Id}
                            year={this.state.p2Year}
                            date={this.state.p2Date}
                            name="p2"
                            customDate={this.state.p2CustomeDate}
                          />
                        </Col>

                        <Col>
                          <FormGroup>
                            <ControlLabel
                              style={{
                                marginRight: "10px",
                                marginLeft: "20px",
                                paddingBottom: "5px",
                                float: "left"
                              }}>
                              <FormattedMessage id="ids_dateDu" />
                            </ControlLabel>

                            <div style={{ float: "left" }}>
                              <CustomDatetime
                                inputProps={{
                                  disabled: false,
                                  onClick: e => e.target.select()
                                }}
                                locale={this.props.locale}
                                defaultValue={displayDatep2Start}
                                value={this.state.p2StartDateForcedValue}
                                onBlur={e => {
                                  console.log("e=", e);
                                  this.handleRangeChangeBudget2Du(
                                    moment(e).startOf("day")._d,
                                    moment(displayDatep2End).endOf("day")._d
                                  );
                                }}
                              />
                            </div>
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <ControlLabel
                              style={{
                                marginRight: "10px",
                                marginLeft: "20px",
                                paddingBottom: "5px",
                                float: "left"
                              }}>
                              <FormattedMessage
                                id="ids_dateAu"
                                description="tax date au"
                                defaultMessage="Au"
                              />
                            </ControlLabel>

                            <div style={{ float: "left" }}>
                              <CustomDatetime
                                inputProps={{
                                  disabled: false,
                                  onClick: e => e.target.select()
                                }}
                                locale={this.props.locale}
                                defaultValue={displayDatep2End}
                                // forcedValue={this.state.forcedValue}   
                                value={this.state.p2EndDateForcedValue}
                                onBlur={e => {
                                  console.log("e=", e);
                                  this.handleRangeChangeBudget2Au(
                                    moment(displayDatep2Start).startOf("day")._d,
                                    moment(e).endOf("day")._d
                                  );
                                }}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>

                      {/* <Row sm="8">

                    <Col
                      sm={2}
                      style={{ paddingTop: "7px", paddingBottom: "5px" }}
                    >
                      <div className="title">
                        <span className="text-capitalize">
                          {this.props.intl.formatMessage({
                            id: "ids_period"
                          })}{" "}
                          1
                        </span>
                      </div>
                    </Col>


                    <Col sm={3}>
                      <BudgetSelect
                        companyId={this.props.companyId}
                        onSelect={this.onBudgetPeriodSelect}
                        type={this.state.p1Type}
                        id={this.state.p1Id}
                        year={this.state.p1Year}
                        date={this.state.p1Date}
                        name="p1"
                        customDate={this.state.p1CustomeDate}
                      />
                    </Col>


                    <Col sm={6}>
                      <DateRangePicker
                        key={Math.random()}
                        handleRangeChange={this.handleRangeChangeBudget1}
                        locale={this.props.intl.locale}
                        from={displayDatep1Start}
                        to={displayDatep1End}
                      />
                    </Col>
                  </Row>


                  <Row sm="8">
                    <Col
                      sm={2}
                      style={{ paddingTop: "7px", paddingBottom: "5px" }}
                    >
                      <div className="title">
                        <span className="text-capitalize">
                          {this.props.intl.formatMessage({
                            id: "ids_period"
                          })}{" "}
                          2
                      </span>
                      </div>
                    </Col>
                    <Col sm={3}>
                      <BudgetSelect
                        companyId={this.props.companyId}
                        onSelect={this.onBudgetPeriodSelect}
                        name="p2"
                        type={this.state.p2Type}
                        id={this.state.p2Id}
                        year={this.state.p2Year}
                        date={this.state.p2Date}
                        customDate={this.state.p2CustomeDate}
                      />
                    </Col>
                    <Col sm={6}>
                      <DateRangePicker
                        key={Math.random()}
                        handleRangeChange={this.handleRangeChangeBudget2}
                        locale={this.props.intl.locale}
                        from={displayDatep2Start}
                        to={displayDatep2End}
                      />
                    </Col>
                  </Row> */}
                    </Grid>
                  </Card>
                </Fragment>
              )}

              {!!this.props.showRangeSelect && (
                <Fragment>
                  {this.state.from && this.state.to && (
                    <h4>
                      {this.props.intl.formatMessage({ id: "ids_du" })}{" "}
                      <strong>{`${displayDateFromStr}`}</strong>{" "}
                      {this.props.intl.formatMessage({ id: "ids_au" })}{" "}
                      <strong>{`${displayDateToStr}`}</strong>
                    </h4>
                  )}
                  <Card
                  // title={this.props.intl.formatMessage({ id: "ids_modifyPeriod" })}
                  >
                    <Grid fluid>
                      <Row sm="12">
                        <Col >
                          <FormGroup>
                            <ControlLabel
                              style={{
                                marginRight: "10px",
                                paddingBottom: "5px",
                                float: "left"
                              }}>
                              <FormattedMessage id="ids_period" />
                              &nbsp;
                              <FormattedMessage id="ids_dateDu" />
                            </ControlLabel>

                            <div style={{ float: "left" }}>
                              <CustomDatetime
                                inputProps={{
                                  disabled: false,
                                  onClick: e => e.target.select()
                                }}
                                locale={this.props.locale}
                                defaultValue={displayDateFromDate}
                                onBlur={e => {
                                  console.log("e=", e);
                                  this.handleRangeChangeDu(
                                    moment(e).startOf("day")._d,
                                    // moment(displayDateToDate).endOf("day")._d
                                    moment(e).endOf("month")._d
                                  );
                                  // const variables = {
                                  //   dateDu: e,
                                  //   dateAu: moment(this.state.dateAu).endOf("day")._d,
                                  //   companyId: this.props.companyId
                                  // };
                                  // this.props.getAllBankAccounts.refetch(variables);
                                  // this.setState({ dateDu: e });
                                }}
                              />
                            </div>
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup>
                            <ControlLabel
                              style={{
                                marginRight: "10px",
                                marginLeft: "20px",
                                paddingBottom: "5px",
                                float: "left"
                              }}>
                              <FormattedMessage
                                id="ids_dateAu"
                                description="tax date au"
                                defaultMessage="Au"
                              />
                            </ControlLabel>

                            <div style={{ float: "left" }}>
                              <CustomDatetime
                                inputProps={{
                                  disabled: false,
                                  onClick: e => e.target.select()
                                }}
                                locale={this.props.locale}
                                defaultValue={displayDateToDate}
                                // forcedValue={this.state.forcedValue}   
                                value={this.state.forcedValue}
                                onBlur={e => {
                                  console.log("e=", e);
                                  this.handleRangeChangeAu(
                                    moment(displayDateFromDate).startOf("day")._d,
                                    moment(e).endOf("day")._d
                                  );
                                }}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Grid>
                  </Card>
                </Fragment>
              )}

              {showPeriodSelect && (
                <Row>
                  <Col md={3}>
                    <span>
                      <Select
                        name="Periode-select"
                        placeholder="Periode"
                        value={currentPeriod}
                        onChange={period => this.onPeriodChange(period)}
                        options={[
                          {
                            value: "M",
                            label: this.props.intl.formatMessage({ id: "ids_month" })
                          },
                          {
                            value: "Q",
                            label: this.props.intl.formatMessage({
                              id: "ids_quarter"
                            })
                          },
                          {
                            value: "S",
                            label: this.props.intl.formatMessage({
                              id: "ids_semester"
                            })
                          },
                          {
                            value: "N",
                            label: this.props.intl.formatMessage({
                              id: "ids_nineMonths"
                            })
                          },
                          {
                            value: "Y",
                            label: this.props.intl.formatMessage({ id: "ids_year" })
                          }
                        ]}
                      >
                        {" "}
                      </Select>
                    </span>
                  </Col>
                  <Col md={1}> </Col>
                  <Col md={3}>
                    {/* <div style={style}> */}
                    <Col className="text-center">
                      <div>
                        <Slider
                          min={minYear}
                          max={maxYear}
                          marks={marks}
                          step={1}
                          included={false}
                          defaultValue={currentYear}
                          handle={handle}
                          onChange={value => {
                            setTimeout(() => {
                              this.onYearChange(value);
                            }, 500);

                          }}
                        />
                      </div>
                    </Col>
                    {/* </div> */}
                    {/* <Select
                name="annee-select"
                placeholder="Années"
                value="2018"
                options={[
                  { value: "2018", label: "2018" },
                  { value: "2017", label: "2017" },
                  { value: "2016", label: "2016" }
                ]}>
                {" "}
              </Select> */}
                  </Col>
                </Row>
              )}

              <Query
                query={this.props.query}
                fetchPolicy="network-only"
                // fetchPolicy="cache-and-network"
                variables={{
                  companyId: this.props.companyId,
                  year: "" + currentYear,
                  dateFrom: fixDateToDataBase(dateFrom || new Date().toJSON()),
                  dateTo: fixDateToDataBase(dateTo || new Date().toJSON()),
                  p1Type: this.state.p1Type,
                  p1Id: this.state.p1Id,
                  p1DateDebut: fixDateToDataBase(this.state.p1StartDate),
                  p1DateFin: fixDateToDataBase(this.state.p1EndDate),
                  p2Type: this.state.p2Type,
                  p2Id: this.state.p2Id,
                  p2DateDebut: fixDateToDataBase(this.state.p2StartDate),
                  p2DateFin: fixDateToDataBase(this.state.p2EndDate)
                }}
              >
                {({ loading, error, data, fetchMore, subscribeToMore, refetch }) => {
                  if (loading) return <Spinner size="lg" fullScreen />;
                  if (error) return `Error! ${error.message}`;
                  if (Chart) {
                    return (
                      <Chart
                        period1Text={period1Text}
                        period2Text={period2Text}
                        companyId={this.props.companyId}
                        currency={
                          this.props.data &&
                          this.props.data.company &&
                          this.props.data.company.currency
                        }
                        showSideModal={this.showSideModal}
                        years={years}
                        //onYearChange={year => this.onYearChange(year)}
                        onPeriodChange={period => this.onPeriodChange(period)}
                        currentPeriod={currentPeriod.value}
                        selectedPeriod={selectedPeriod}
                        onSelectedPeriod={this.onSelectedPeriod}
                        previousYear={previousYear}
                        currentYear={currentYear}
                        loading={loading}
                        refetch={refetch}
                        subscribeToMore={subscribeToMore}
                        error={error}
                        data={data}
                        showChart={showChart}
                        showData={this.props.showData}
                        // onDataChange={data => this.onDataChange(data)}
                        name={this.props.name}
                        onLoadMore={(cursor, resultKey) => {
                          fetchMore({
                            variables: {
                              cursor: cursor
                            },
                            updateQuery: (previousResult, { fetchMoreResult }) => {
                              const newEdges = fetchMoreResult[resultKey].edges;
                              const pageInfo = fetchMoreResult[resultKey].pageInfo;
                              const aggregate = fetchMoreResult[resultKey].aggregate;

                              // console.log("871 - previousResult=", previousResult);
                              // console.log("869 - fetchMoreResult=", fetchMoreResult);

                              // const max = (previousResult._ecritureLinesForRentabilityMeta &&
                              //   previousResult._ecritureLinesForRentabilityMeta.count) || 0;

                              // const cur = (previousResult.ecritureLinesConnectionForRentability &&
                              //   previousResult.ecritureLinesConnectionForRentability.edges &&
                              //   previousResult.ecritureLinesConnectionForRentability.edges.length) || 0;

                              // if (cur+NEXT > max) {
                              //   console.log('881 - return previousResult=', cur, max);
                              //   return previousResult;
                              // }

                              return newEdges.length
                                ? // Put the new comments at the end of the list and update `pageInfo`
                                // so we have the new `endCursor` and `hasNextPage` values
                                {
                                  [resultKey]: {
                                    __typename:
                                      previousResult[resultKey].__typename,
                                    edges: [
                                      ...previousResult[resultKey].edges,
                                      ...newEdges
                                    ],
                                    pageInfo,
                                    aggregate
                                  }
                                }
                                : previousResult;
                            }
                          });
                        }}
                      />
                    );
                  } else {
                    return <div />;
                  }
                }}
              </Query>
            </div>
          </div>
        </Grid>
      </div >
    );
  }
}

export default compose(
  data,
  graphql(Queries.getCompanyInfoForContainer, { name: "companyDefaultInfos" }),
  injectIntl
)(withRouter(ReportingContainer));
